import { useReducer } from 'react'

const useToggle = (defaultValue = false) => {
  return useReducer((state) => !state, defaultValue)
}

export default useToggle
